import listActions from 'src/modules/meditation/list/meditationListActions';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';
import MeditationService from '../meditationService';

const prefix = 'MEDITATION_UNARCHIVE';

const meditationUnarchiveActions = {
  UNARCHIVE_STARTED: `${prefix}_UNARCHIVE_STARTED`,
  UNARCHIVE_SUCCESS: `${prefix}_UNARCHIVE_SUCCESS`,
  UNARCHIVE_ERROR: `${prefix}_UNARCHIVE_ERROR`,

  UNARCHIVE_ALL_STARTED: `${prefix}_UNARCHIVE_ALL_STARTED`,
  UNARCHIVE_ALL_SUCCESS: `${prefix}_UNARCHIVE_ALL_SUCCESS`,
  UNARCHIVE_ALL_ERROR: `${prefix}_UNARCHIVE_ALL_ERROR`,

  doUnarchive: (id) => async (dispatch) => {
    try {
      dispatch({
        type: meditationUnarchiveActions.UNARCHIVE_STARTED,
      });

      await MeditationService.unarchiveAll([id]);

      dispatch({
        type: meditationUnarchiveActions.UNARCHIVE_SUCCESS,
      });

      Message.success(
        i18n('entities.meditation.unarchive.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/meditation');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: meditationUnarchiveActions.UNARCHIVE_ERROR,
      });
    }
  },

  doUnarchiveAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type:
          meditationUnarchiveActions.UNARCHIVE_ALL_STARTED,
      });

      await MeditationService.unarchiveAll(ids);

      dispatch({
        type:
          meditationUnarchiveActions.UNARCHIVE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.meditation.unarchiveAll.success'),
      );

      getHistory().push('/meditation');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          meditationUnarchiveActions.UNARCHIVE_ALL_ERROR,
      });
    }
  },
};

export default meditationUnarchiveActions;
